// extracted by mini-css-extract-plugin
module.exports = {"Root":"css-modules_Root__rbPf2","Image":"css-modules_Image__r52a7","Fallback":"css-modules_Fallback__3g7DG"};